import Select from '@/components/Select';
import { COMPANY_ORDER_ITEMS, COMPANY_VISIBLE_ITEMS } from '../constants';
import CompaniesVisibleDialog from './CompaniesVisibleDialog';
import type SharedCustomField from '@/types/serializers/SharedCustomField';

type Props = {
  sort: string;
  setSort: (value: string) => void;
  visibleFields: string[];
  setVisibleFields: (fields: string[]) => void;
  customFields: SharedCustomField[];
};

export default function CompaniesVisibleChangeBox({
  sort,
  setSort,
  visibleFields,
  setVisibleFields,
  customFields,
}: Props) {
  return (
    <div className="mt-5 flex items-end">
      <div className="flex w-[196px] shrink-0 flex-col gap-2">
        <Select
          className="w-full"
          onValueChange={setSort}
          value={sort}
          items={COMPANY_ORDER_ITEMS}
        />
      </div>
      <div className="ml-auto">
        <CompaniesVisibleDialog
          customFields={[
            ...COMPANY_VISIBLE_ITEMS,
            ...customFields.map((field) => ({
              label: field.name,
              type: `custom_field_${field.id}`,
            })),
          ]}
          visibleFields={visibleFields}
          setVisibleFields={setVisibleFields}
        />
      </div>
    </div>
  );
}
